<template>
  <vue-js-modal
    v-if="mapper"
    :key="reload"
    id="agMapperModal"
    class="agModal"
    name="agMapperModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Mapper {{mapper.shortname}}</h4>
        <h4 v-else class="agModal-title">Edit Mapper {{mapper.shortname}}</h4>
      </template>

      <div class="agInputGroup agInputGroupCentered">
        <label>Source:</label>
        <b-input
          type="text"
          :value="srcStr"
          autocomplete="false"
          disabled
        ></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input
          type="text"
          v-model="mapper.name"
          autocomplete="false"
          :disabled="disableUI || isLoading">
        </b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input
          type="text"
          v-model="mapper.description"
          autocomplete="false"
          :disabled="disableUI || isLoading">
        </b-input>
      </b-input-group>
      <hr/>
      <div class="agInputGroup agInputGroupCentered">
        <label>Map To:</label>
        <b-form-select
          id="agMapperModal-mapObject"
          class="agLargeInput"
          v-model="mapper.mapObject"
          :options="mapObjects"
          :disabled="disableUI || isLoading"
          @change="mapObjectSelect_change">
        </b-form-select>
      </div>
      <hr/>
      <div class="agInputGroup">
        <b-table
          :key="'mods-' + reloadMods"
          id="agMapperModal-modTable"
          :fields="modHeaders"
          :items="mods"
          :thead-class="{ theadHidden: isLoadingMods }"
          borderless
          outlined
          small>
          <template #head(modNo)>
            {{'No.'}}
          </template>
          <template #head(equals)>
            =
          </template>
          <template #cell(modNo)="data">
            <div class="agMapperModal-modNo">{{ data.index + 1 }}</div>
          </template>
          <template #cell(field)="data">
            <b-form-select
              v-model="data.item.field"
              class="agMapperModal-modField"
              disabled>
              <option :value="data.value">{{
                getFieldText(data.value)
              }}</option>
            </b-form-select>
          </template>
          <template #cell(equals)>
            <div class="agMapperModal-modEquals">=</div>
          </template>
          <template #cell(value)="data">
            <div class="agMapperModal-modValue">       
              <ag-input-select
                :useSubInput="true"
                :inputModel="data.item.value.value"
                :selectModel="data.item.value.field"
                :workflow="workflow"
                :groups="values"
                :width="400"
                :disabled="disableUI || isLoading"
                @input_keyup="modValueInput_keyup($event, data.item)"
                @select_change="modValueSelect_change($event, data.item)">
              </ag-input-select>
              <b-button
                v-if="data.item.errors && data.item.errors.length > 0"
                class="agMapperModal-modErrorButton agImageButton"
                :disabled="disableUI || isLoading"
                @click="modErrorButton_click(data.item)">
                <fa icon="exclamation-circle"/>
              </b-button>
            </div>     
          </template>
        </b-table>
        <b-spinner
          v-if="isLoadingMods"
          id="agMapperModal-loadingModsSpinner"
        ></b-spinner>
      </div>
      <hr/>
      <div class="agInputGroup agInputGroupCentered">
        <label>Destination:</label>
        <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
      </div>
     
      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- mod error modal -->
    <b-modal
      class="agModal"
      ref="modErrorModal"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <template slot="modal-header">
        <h4 class="agModal-title danger">Mod Error</h4>
      </template>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonRight" @click="cancel">
          OK
        </b-button>
      </template>
    </b-modal>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Mapper</h4>
      </template>
      Are you sure you want to delete mapper
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">
          Cancel
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>

<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Vue from "vue";
import Util from "src/util/util";
import { EventBus } from "src/eventBus";

export default {
  name: "ag-mapper-modal",
  components: {
    "ag-input-select": InputSelect
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean,
    validation: Object
  },
  data() {
    return {
      mapper: null,
      reload: 0,
      reloadMods: 0,
      isLoading: false,
      isLoadingMods: false,
      modalMessage: "",
      modalMessageClass: "",
      mods: [],
      modErrors: [],
      modHeaders: ["modNo", "field", "equals", "value"],
      values: {},
    };
  },
  computed: {

    name() {
      if (this.mapper.name)
        return this.mapper.name;
      
      return this.mapper.shortname;
    },

    srcStr() {
      if (!this.mapper.src || this.mapper.src.length == 0) 
        return "";

      var srcStr = "";
      for (var i = 0; i < this.mapper.src.length; i++) {
        var src = this.mapper.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.mapper.dest) 
        return this.mapper.dest.shortname;
      return "";
    },

    mapObjects() {
      let mapObjects = [];

      var types = this.$store.getters["nodeStore/getOutputTypes"];
      for (var i = 0; i < types.length; i++) {
        var type = types[i];
        if (!type.plural) continue;

        for (var j = 0; j < this.workflow[type.plural].length; j++) {
          var output = this.workflow[type.plural][j];
          var name = output.shortname;
          if (output.name) {
            name += ": " + output.name;
          }
          var value = {
            type: type.type,
            shortname: output.shortname
          };

          var option = { value: value, text: name };
          mapObjects.push(option);
        }
      }
      return mapObjects;
    },
  },

  watch: {},

  methods: {

    // UI Events

    cancelButton_click() {
      this.hide();
    },

    async saveButton_click() {
      this.modalMessage = "";

      // build mapper.mods w/ mods that actually have values
      let validMods = [];
      for (let i = 0; i < this.mods.length; i++) {
        let mod = this.mods[i];
        if (mod.value.value || mod.value.field) {
          let validMod = JSON.parse(JSON.stringify(mod));
          delete validMod.errors;
          validMods.push(validMod);
        }
      }
      this.mapper.mods = validMods;

      let node = {
        object: this.mapper,
        type: "mapper"
      };
      this.isLoading = true;
      let result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        let updated = {
          type: "mapper",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      let node = {
        object: this.mapper,
        type: "mapper"
      };
      this.isLoading = true;
      let result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    mapObjectSelect_change() {
      setTimeout(() => {
        this.setValues();
        this.setMods();
      }, 250);
    },

    modValueInput_keyup(value, mod) {
      mod.value.value = value;
      mod.value.field = null;
    },

    modValueSelect_change(value, mod) {
      if (value.field == "-- None --") {
        mod.value.field = null;
        this.reloadMods++;
      } else {
        mod.value.field = value;
      }
      mod.value.value = null;
    },

    modErrorButton_click(mod) {
      if(mod.errors) {
        let message = "";
        for(let i = 0; i < mod.errors.length; i++)
          message += `- ${mod.errors[i]}\n\n`;
  
        EventBus.$emit("showAlert", {
          title: `Mod Error`,
          message: message,
          type: "error"
        });
      }
    },

    // other
    async show() {
      await this.setMapper();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agMapperModal");
    },

    hide() {
      this.$modal.hide('agMapperModal');
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";


      await this.setValues();
      await this.setModErrors();
      await this.setMods();
    },

    async setMapper() {
      if (this.node && this.node.type == "mapper")
        this.mapper = this.workflow.mappers.find(
          object => object._id == this.node.object._id
        );
      else 
        this.mapper = null;
    },

    async setModErrors() {
      // pull any mod errors from workflow validation
      this.modErrors = {};
      if(this.validation) {
        let nodeValidation = this.validation.nodes.find((n) => n.shortname == this.mapper.shortname);
        if(nodeValidation && nodeValidation.errors) {
          for(let i = 0; i < nodeValidation.errors.length; i++) {
            let error = nodeValidation.errors[i];
            if(error.indexOf("Row ") < 0)
              continue;

            let modNo = error.substring(0, error.indexOf(":"));
            error = error.replace(`${modNo}: `, "");
            modNo = modNo.replace("Row ", "");

            let errors = this.modErrors[modNo];
            if(!errors)
              errors = [];
            errors.push(error);
            this.modErrors[modNo] = errors;
          }
        }
      }
    },

    async setMods() {
      this.isLoadingMods = true;
      this.mods = [];

      if (!this.mapper.mapObject) {
        this.isLoadingMods = false;
        this.reloadMods++;
        return;
      }

      let fields;
      let outputFields = Util.getOutputFields(this.$store, this.workflow);
      for(let i = 0; i<Object.keys(outputFields).length; i++) {
        if(outputFields[Object.keys(outputFields)[i]][0].object == this.mapper.mapObject.shortname) {
          fields = outputFields[Object.keys(outputFields)[i]];
        }
      }
      if (!fields) {
        this.isLoadingMods = false;
        this.reloadMods++;
        return;
      }
      
      for (let i = 0; i < fields.length; i++) {
        let field = fields[i];
        let mod = {
          field: field
        };
        let existing = null;

        for (let m = 0; m < this.mapper.mods.length; m++) {
          let mm = this.mapper.mods[m];
          if (mm.field.field == field.field) {
            if (mm.field.child && field.child) {
              if (mm.field.child.shortname == field.child.shortname)
              {
                existing = mm;
              }
            } 
            else{
              existing = mm;
            }
          }
        }
        if (existing) {
          mod.value = {
            field: existing.value.field,
            value: existing.value.value
          };

          // check if mod has errors
          let index = this.mods.length;
          if(this.modErrors[index + 1])
            mod.errors = this.modErrors[index + 1];
        } 
        else {
          mod.value = {
            field: null,
            value: null
          };
        }
        this.mods.push(mod);
      }

      this.isLoadingMods = false;
      this.reloadMods++;
    },

    async setValues() {
      // add -- None -- to be able to blank out fields
      this.values = {
        " ": [
          {
            value: { object: "", field: "-- None --" },
            text: "-- None --"
          }
        ]
      };
      let inputFields = Util.getInputFields(this.$store, this.workflow);
      let optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.values, optionGroups);
    },

    getFieldText(field) {
      if (field.child) {
        var output = this.workflow.outputs.find(
          a => a.shortname == this.mapper.mapObject.shortname
        );
        var child = output.childObjects.find(
          a => a.shortname == field.child.shortname
        );
        if (child) {
          if((child.value) !==undefined){
            var text = child.shortname + ": " + child.name+"." + field.field+" "+ child.value;
            return text;
          }else{
            var text = child.shortname + ": " + child.name+"." + field.field;
            return text;
          }
        }
      }
      return field.field;
    }
  }
};
</script>

<style scoped lang="css">
#agMapperModal-modTable {
  text-align: center;
  width: 1000px;
  margin: auto;
}

#agMapperModal-loadingModsSpinner {
  position: relative;
  left: 50%;
  margin-left: -20px;
}

.agMapperModal-modField {
  width: 400px;
  display: inline-block;

  -webkit-appearance: none;
  -moz-appearance: none;
}

.agMapperModal-modField::-ms-expand {
  display: none;
}

.agMapperModal-modNo {
  position: relative;
  top: 7.5px;
}

.agMapperModal-modEquals {
  position: relative;
  top: 7.5px;
}

.agMapperModal-modValue {
  margin-left: 15px;
  text-align: left;
}

.agMapperModal-modErrorButton {
    position: relative;
    top: 2.5px;
    margin-left: 10px;
    font-size: 20px;
    cursor: pointer;
    color: #DC3545;
}

.agMapperModal-modError:hover {
    color: #C82333;
}


</style>



// WEBPACK FOOTER //
// src/components/nodes/MapperModal.vue